import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 引入Element UI样式
import "swiper/css/swiper.css";
import VueI18n from 'vue-i18n'
import localforage from 'localforage'
//引入vant
import Vant from 'vant';
import 'vant/lib/index.css';
// 接口配置
import axios from "./utils/api";
// 引入字体样式
import './assets/fonts/fonts.css'


Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.use(VueI18n)
Vue.use(localforage)
Vue.use(Vant);
Vue.prototype.$handlePadding = handlePadding;

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'zh-CN',
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'zh-CN': require('./lang/zh'), // 中文语言包
    'en-US': require('./lang/en') // 英文语言包
  }
})

function handlePadding() {
  if (Vue.prototype.$isMobile) {
    let MutationObserver =
      window.MutationObserver ||
      window.WebKitMutationObserver ||
      window.MozMutationObserver;

    let observer = new MutationObserver((mutations) => {
      //console.log('mutations',mutations)
      mutations.forEach((item) => {
        if ("style" == item.attributeName) {
          document.body.style.padding = 0;
        }
      });
    });

    var body = document.body;

    var options = {
      attributes: true,
    };

    observer.observe(body, options);
  }
}

const demoDataBase = localforage.createInstance({
  name: 'payDataBase'
})
Vue.prototype.$demoDataBase = demoDataBase
Vue.prototype.$http = axios
Vue.prototype.$isMobile = /Mobile|Android|iphone|ipad|ipod|IOS|Macintosh|Surface Pro 7/i.test(navigator.userAgent);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
